import { notification, Typography } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../components/base/Loading';
import TaskDefinitionForm from '../components/tasks/TaskDefinitionForm';
import {
  useGetModulesWithCategoriesQuery,
  useGetTaskDefinitionQuery,
  useGetTaskDefinitionSettingsQuery,
  useUpdateTaskDefinitionSettingsMutation,
} from '../graphql/schema';
import TaskDefinitionHeader from '../components/tasks/TaskDefinitionHeader';

const TaskDefinitionSettings = () => {
  const { taskDefinitionId } = useParams();
  const navigate = useNavigate();

  const [notificationApi, notificationContextHolder] =
    notification.useNotification();

  const [loading, setLoading] = useState<boolean>(false);

  const { data, loading: dataLoading } = useGetTaskDefinitionQuery({
    variables: {
      id: taskDefinitionId ?? '',
    },
    skip: !taskDefinitionId,
  });

  const { data: settings, loading: settingsLoading } =
    useGetTaskDefinitionSettingsQuery({
      variables: {
        taskDefinitionId: taskDefinitionId ?? '',
      },
      skip: !taskDefinitionId,
    });

  const [updateSettings] = useUpdateTaskDefinitionSettingsMutation();

  const handleSubmit = useCallback(
    async (formValues: any) => {
      setLoading(true);
      await updateSettings({
        variables: {
          taskDefinitionId: taskDefinitionId ?? '',
          dto: {
            settings: formValues,
          },
        },
        refetchQueries: ['GetTasks'],
      });

      setLoading(false);

      notificationApi.success({
        message: 'Die Einstellungen wurden gespeichert.',
      });

      navigate(-1);
    },
    [taskDefinitionId, navigate, updateSettings],
  );

  const { data: modules, loading: modulesLoading } =
    useGetModulesWithCategoriesQuery();

  const [module, category] = useMemo(() => {
    if (modules) {
      for (const m of modules.modulesWithCategories) {
        if (m.categories) {
          for (const c of m.categories) {
            if (c.id === data?.taskDefinition.categoryId) {
              return [m, c];
            }
          }
        }
      }
    }

    return [undefined, undefined];
  }, [data, modules]);

  if (dataLoading || settingsLoading) return <Loading />;

  return (
    <div className="p-5 flex justify-center">
      <div className="bg-white w-full rounded-xl p-5 shadow max-w-[1200px]">
        {notificationContextHolder}

        {data?.taskDefinition && (
          <>
            <TaskDefinitionHeader taskDefinition={data.taskDefinition} />

            <Typography.Title level={3}>Einstellungen</Typography.Title>

            <TaskDefinitionForm
              values={settings?.taskDefinitionSettings.settings}
              schema={data?.taskDefinition.settingsFormDefinition}
              onSubmit={handleSubmit}
              saveButtonLabel="Speichern"
              loading={loading}
              hideSaveButtonIcon
            />
          </>
        )}
      </div>
    </div>
  );
};

export default TaskDefinitionSettings;
